import React from "react"
import * as Yup from "yup"
import { Button, StyledModalActions } from "gatsby-interface"
import { Form, FormElement } from "@modules/form/components/Form"
import { InputConnectedField } from "gatsby-interface"
import { sites as text } from "@modules/locales/default.js"

const ERROR_MESSAGE = `Please make sure your input matches the site name.`

function createSchema(siteName) {
  return Yup.object().shape({
    siteNameInput: Yup.string()
      .required(`Required`)
      .test(`nameEquality`, ERROR_MESSAGE, function(value) {
        return value === siteName
      }),
  })
}

function DeleteSiteForm({ submitCallback, cancelCallback, siteId, siteName }) {
  return (
    <Form
      initialValues={{ siteNameInput: ``, siteName, siteId }}
      initialErrors={{ siteNameInput: ERROR_MESSAGE }}
      validationSchema={createSchema(siteName)}
      onSubmit={values => {
        submitCallback(values.siteId)
      }}
    >
      {({ isSubmitting, isValid }) => (
        <FormElement>
          <InputConnectedField
            name="siteNameInput"
            label="Site name:"
            hint={text.losePreviewUrl}
            required
            data-cy="delete-site-name-input"
          />

          <StyledModalActions>
            <Button
              variant="SECONDARY"
              tone="NEUTRAL"
              type="reset"
              onClick={cancelCallback}
              data-cy="delete-site-modal-cancel-button"
            >
              {text.cancel}
            </Button>
            <Button
              type="submit"
              tone="DANGER"
              data-cy="delete-site-modal-submit-button"
              loading={isSubmitting}
              loadingLabel="Deleting"
              disabled={!isValid}
            >
              {text.yesDeleteSite}
            </Button>
          </StyledModalActions>
        </FormElement>
      )}
    </Form>
  )
}

DeleteSiteForm.propTypes = {}

export default DeleteSiteForm
